import StatesEnum from '../enums/StatesEnum';

export const canEditGuarantorData: StatesEnum[] = [
  StatesEnum.GUARANTOR_REGISTRATION_COMPLETED,
  // v3
  StatesEnum.SCORE_REGISTRATION_COMPLETED,
  StatesEnum.CREDIT_REGISTRATION_COMPLETED,
];

export const canChangePaymentMethod: StatesEnum[] = [
  StatesEnum.DISAPPROVED,
  // v3
  StatesEnum.SCORE_DISAPPROVED,
  StatesEnum.CREDIT_DISAPPROVED,
  StatesEnum.SECOND_GUARANTOR_REGISTRATION,
];

export const canSendToAnalisys: StatesEnum[] = [
  // v2
  StatesEnum.GUARANTOR_REGISTRATION_COMPLETED,
  // v3
  StatesEnum.SCORE_REGISTRATION_COMPLETED,
  StatesEnum.CREDIT_REGISTRATION_COMPLETED,
];

export const shouldHaveGuarantor: StatesEnum[] = [
  // v2
  StatesEnum.GUARANTOR_REGISTRATION_COMPLETED,
  StatesEnum.SECOND_GUARANTOR_REGISTRATION_FORM,
  StatesEnum.DISAPPROVED,
  // v3
  StatesEnum.SCORE_REGISTRATION_COMPLETED,
  StatesEnum.CREDIT_REGISTRATION_COMPLETED,
  StatesEnum.SECOND_GUARANTOR_REGISTRATION,
  StatesEnum.SCORE_DISAPPROVED,
  StatesEnum.CREDIT_DISAPPROVED,
];

export const shouldHaveTwoGuarantor: StatesEnum[] = [
  // v2
  StatesEnum.GUARANTOR_REGISTRATION_COMPLETED,
  StatesEnum.DISAPPROVED,
  // v3
  StatesEnum.CREDIT_REGISTRATION_COMPLETED,
  StatesEnum.CREDIT_DISAPPROVED,
];
